import {useEffect, useState} from "react";
import {getWants} from "../services/api";
import {Link} from "react-router-dom";

export default function ListWants() {
    const [wants, setWants] = useState([])
    useEffect(() => {
        getWants()
            .then(apiWants => {
                setWants(apiWants)
            })
            .catch(ex => {
                console.log("Error getting wants: ", wants)
            })
    }, []);
    
    return (
        <>
            {wants && wants.length > 0 &&
                <>
                    
                    {wants.map(swimlane=> {
                        return(<div className="card mb-3">
                            <div className="card-header">
                                <span className="float-start">{swimlane.swimlaneName}</span>
                                <span className="float-end">{swimlane.total}</span>
                            </div>
                            <div className="card-body">
                                <table className="table table-striped">
                                    <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Priority</th>
                                        <th>Cost</th>
                                        <th>Achievement Date</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {swimlane.wants.map(w => {
                                        return (
                                            <tr key={w.wantId}>
                                                <td><Link to={`/wants/${w.wantId}/edit`}>{w.name}</Link></td>
                                                <td>{w.priority}</td>
                                                <td>{w.cost}</td>
                                                <td>{w.achievementDate ? new Date(w.achievementDate).toLocaleDateString() : ""}</td>
                                            </tr>
                                        )
                                    })}
                                    </tbody>
                                </table>
                                {swimlane.swimlaneId && <Link to={`/swimlanes/${swimlane.swimlaneId}/edit`} className="ms-3 btn btn-primary">Edit Swimlane</Link> }

                            </div>


                        </div>)

                    })}


                </>
            }

            <div className="mt-3">
                <Link to={"/wants/new/edit"} className="btn btn-primary">Add Want</Link>
                <Link to={"/swimlanes/new/edit"} className="ms-3 btn btn-primary">Add Swimlane</Link>
            </div>
        </>
    )
}